import { render, staticRenderFns } from "./editRongYu.vue?vue&type=template&id=4de88b23&scoped=true"
import script from "./editRongYu.vue?vue&type=script&lang=js"
export * from "./editRongYu.vue?vue&type=script&lang=js"
import style0 from "./editRongYu.vue?vue&type=style&index=0&id=4de88b23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de88b23",
  null
  
)

export default component.exports